import ApiKeyField from './ApiKeyField'
import EndpointField from './EndpointField'
import ModelField from './ModelField'

/** Model, key, and — for self-hosted or Azure providers — the endpoint. */
export default function CustomModelFields({ form, saved }) {
  const { draft, errors, provider, setField } = form
  return (
    <>
      <ModelField
        provider={provider}
        value={draft.model}
        error={errors.model}
        onChange={(next) => setField('model', next)}
      />
      <ApiKeyField
        provider={provider}
        value={draft.apiKey}
        error={errors.apiKey}
        saved={saved?.provider === provider.id ? saved : null}
        onChange={(next) => setField('apiKey', next)}
      />
      {provider.baseUrlPlaceholder ? (
        <EndpointField
          placeholder={provider.baseUrlPlaceholder}
          value={draft.baseUrl}
          error={errors.baseUrl}
          onChange={(next) => setField('baseUrl', next)}
        />
      ) : null}
    </>
  )
}
